import {useContext} from 'react';
import Icon, {ICONS} from 'patient-ping-remedy/packages/icon';
import ToolTip from 'patient-ping-remedy/packages/tool-tip';
import ContextMenu from 'patient-ping-remedy/packages/context-menu';
import {CarecoApiContext} from '@/app-context/careco-api-context';
import {MessageThreadSummary} from '@/api/dto/message';
import {ItemWrapper, ItemContent} from '@/components/pages/messages/details/MessageThreadDetails.styles';
import FileHelpers from '@/helpers/file_helpers';

type Props = {
  messageThreadSummary?: MessageThreadSummary;
  concise?: boolean;
  interactive?: boolean;
}

export default function MessageThreadAttachments({ messageThreadSummary, concise, interactive }: Props) {
  const { carecoApi } = useContext(CarecoApiContext);

  if (!messageThreadSummary || messageThreadSummary.attachments.length === 0) {
    return null;
  }

  const content = (
    <ItemContent concise={concise}>
      <Icon iconClass={ICONS.paperclip} iconSize={concise ? '1x' : 'lg'} />
      <span>
        {messageThreadSummary.attachments.length}{' '}
        {!concise && (messageThreadSummary.attachments.length === 1 ? 'attachment' : 'attachments')}
      </span>
    </ItemContent>
  );

  if (interactive) {
    const attachments = messageThreadSummary.attachments.map((attachment) => {
      const filename = attachment.s3Key.split('/').pop() ?? 'Unknown';
      return {
        label: filename,
        async action() {
          const response = await carecoApi?.getMessageAttachment(attachment.id);
          if (response) {
            const arrayBuffer = FileHelpers.base64ToArrayBuffer(response);
            FileHelpers.handleFile(arrayBuffer, filename);
          }
        },
      };
    });

    return (
      <ItemWrapper>
        <ContextMenu menuItems={attachments}>
          {content}
        </ContextMenu>
      </ItemWrapper>
    );
  }

  const attachments = messageThreadSummary.attachments
    .map((attachment) => attachment.s3Key.split('/').pop() ?? 'Unknown')
    .join(', ');

  return (
    <ItemWrapper>
      <ToolTip text={attachments} position="bottom" type="dark">
        {content}
      </ToolTip>
    </ItemWrapper>
  );
}
